export const getParamFromSearch = (search, field) => {
  const searchParams = new URLSearchParams(search);
  return searchParams.get(field);
};
